<template>
  <div class="container-fluid">
    <input id="article-category-images" v-if="galleryOptions !== null" v-file-uploader="galleryOptions" type="file" name="files" class="gallery_media" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script src="../../../../assets/libs/fileuploader-2.2/jquery.fileuploader.min.js" type="text/javascript"></script>

<script>

import VueFileUploader from "./../../../../directives/VueFileUploader.js";

export default {
  name: "ArticleCategoryImages",
  components: {},
  directives: {
    VueFileUploader
  },
  props: ['articleCategory'],
  data() {
    return {
      galleryOptions: null
    };
  },
  mounted() {
    console.log('ArticleCategoryImages mounted');

    var files = [];

    if (this.articleCategory.imageUrls !== null) {
      files = this.articleCategory.imageUrls.map(imageUrl => (
      {
          name: 'articleCategory.jpg',
          size: 1,
          type: 'image/jpg',
          file: imageUrl,
          data: {
            url: imageUrl
          }
        }
      ));
    }

    const url = process.env.VUE_APP_API +'/ArticleCategoryImages/' + this.articleCategory.articleCategoryId;

    console.log(url);

    this.galleryOptions = {
      name: 'article-category-images',
      extensions: ['image/*', 'video/*'],
      deletingImage: false,
      uploadUrl: url,
      deleteUrl: url,
      sortUrl: url,
      files: files,
      limit: 1
    };

    console.log('galleryOptions:', this.galleryOptions);
  },
  beforeDestroy: function() {
  },
  methods: {}
};
</script>